import styled from 'styled-components';

export const FormContainer = styled.form`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding: 1.5rem;
	background-color: #f9f9f9;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	max-width: 600px;
	margin: 1rem auto;

	@media (max-width: 768px) {
		padding: 1rem; 
		margin: 0.5rem auto; 
	}
`;

export const FormGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const Label = styled.label`
	font-weight: bold;
	color: #333;
	margin-bottom: 0.25rem; 
	display: block; 
`;

export const Input = styled.input`
	padding: 0.75rem;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 1rem;
	width: 100%; 
	box-sizing: border-box; 
	&:focus {
		outline: none;
		border-color: #007bff;
		box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
	}
`;

export const TextArea = styled.textarea`
	padding: 0.75rem;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 1rem;
	font-family: inherit;
	min-height: 100px;
	resize: vertical;
	width: 100%; 
	box-sizing: border-box; 
	&:focus {
		outline: none;
		border-color: #007bff;
		box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
	}
`;

export const Select = styled.select`
	padding: 0.75rem;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 1rem;
	background-color: white;
	width: 100%; 
	box-sizing: border-box; 
	&:focus {
		outline: none;
		border-color: #007bff;
		box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
	}
`;

export const Button = styled.button`
	padding: 0.75rem 1.5rem;
	background-color: var(--color-accent, #007bff); 
	color: white;
	border: none;
	border-radius: 4px;
	font-size: 1rem;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 0.2s ease-in-out;
	align-self: flex-start;
	margin-top: 0.5rem;

	&:hover:not(:disabled) {
		background-color: var(
			--color-accent-dark,
			#0056b3
		); 
	}

	&:disabled {
		background-color: #ccc;
		cursor: not-allowed;
	}

	@media (max-width: 768px) {
		align-self: stretch; 
		padding: 0.85rem; 
	}
`;

export const ErrorMessage = styled.p`
	color: red;
	font-size: 0.875rem;
	margin: 0.25rem 0 0 0; 
`;
